module.exports = __webpack_public_path__ + "static/media/lanchain.0eb5243f.png";